import api from './../../lib/api';

export const LLM_REQUESTS_LOAD = 'LLM_REQUESTS_LOAD';
export const LLM_REQUEST_DETAILS_LOAD = 'LLM_REQUEST_DETAILS_LOAD';

const LLM_REQUESTS_LOADING_CHANGE = 'LLM_REQUESTS_LOADING_CHANGE';
const LLM_REQUESTS_LIST_CHANGE = 'LLM_REQUESTS_LIST_CHANGE';
const LLM_REQUEST_DETAILS_LOADING_CHANGE = 'LLM_REQUEST_DETAILS_LOADING_CHANGE';
const LLM_REQUEST_DETAILS_CHANGE = 'LLM_REQUEST_DETAILS_CHANGE';
const LLM_REQUEST_DETAILS_CLEAR = 'LLM_REQUEST_DETAILS_CLEAR';

const default_pagination = {
    current_page: 1,
    per_page: 20,
    total: 0,
    last_page: 1,
};

const state = {
    requests_list: [],
    request_details: {},
    requests_loading: false,
    details_loading: false,
    pagination: {
        ...default_pagination
    },
};

const actions = {
    /**
     * Загружает список LLM запросов с фильтрами
     */
    [LLM_REQUESTS_LOAD]({ commit, state }, params = {}) {
        return api.list(
            'llm.monitoring.requests',
            null,
            params,
            state,
            commit,
            LLM_REQUESTS_LOADING_CHANGE,
            LLM_REQUESTS_LIST_CHANGE
        );
    },

    /**
     * Загружает детали LLM запроса
     */
    [LLM_REQUEST_DETAILS_LOAD]({ commit, state }, requestId) {
        return api.load(
            'llm.monitoring.request.details',
            requestId,
            state,
            commit,
            LLM_REQUEST_DETAILS_LOADING_CHANGE,
            LLM_REQUEST_DETAILS_CHANGE
        );
    },
};

const mutations = {
    [LLM_REQUESTS_LOADING_CHANGE](state, data) {
        state.requests_loading = data;
    },

    [LLM_REQUESTS_LIST_CHANGE](state, data) {
        if (data?.data) {
            state.requests_list = data.data;
            state.pagination = {
                current_page: data.page || default_pagination.current_page,
                per_page: data.per_page || default_pagination.per_page,
                total: data.total || default_pagination.total,
            };
        } else {
            state.requests_list = [];
            state.pagination = {
                ...default_pagination
            };
        }
    },

    [LLM_REQUEST_DETAILS_LOADING_CHANGE](state, data) {
        state.details_loading = data;
    },

    [LLM_REQUEST_DETAILS_CHANGE](state, data) {
        if (data?.data) {
            state.request_details = data.data;
        } else {
            state.request_details = {};
        }
    },

    [LLM_REQUEST_DETAILS_CLEAR](state) {
        state.request_details = {};
    },
};

export default {
    state,
    actions,
    mutations,
};